import { ResourceDefinition, ResourceSections } from 'src/types';

export const ApiFieldsResource: ResourceDefinition = {
  name: 'api_fields',
  section: ResourceSections.CLIENT_API,
};
